// import React, { useEffect, useState } from "react";
// import ProjectDetailsPartOne from "../../components/ProjectPageComponents/ProjectDetailsPartOne";
// import ProjectDetailsPartTwo from "../../components/ProjectPageComponents/ProjectDetailsPartTwo";
// import ProjectDetailsPartThree from "../../components/ProjectPageComponents/ProjectDetailsPartThree";
// import Slider from "../../components/ProjectPageComponents/Slider";
// import { useParams } from "react-router-dom";
// import axios from "axios";

// const ProjectDetails = () => {
//   const { id } = useParams();
//   const [singleProject, setSingleProject] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const ProductDetail = () => {
//     let data = "";

//     let config = {
//       method: "get",
//       maxBodyLength: Infinity,
//       url: `${process.env.REACT_APP_API_URL}/projects/project-by-id/${id}`,
//       headers: {},
//       data: data,
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log(JSON.stringify(response.data));
//         setSingleProject(response.data);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.log(error);
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     ProductDetail();
//   }, [id]);

//   if (loading) {
//     return (
//       <>
//         <div className="relative w-full h-[500px] bg-gray-100 overflow-hidden p-4 animate-pulse">
//           <div className="absolute top-1/2 left-4 -translate-y-1/2 w-8 h-8 rounded-full bg-gray-300"></div>

//           <div className="absolute top-1/2 right-4 -translate-y-1/2 w-8 h-8 rounded-full bg-gray-300"></div>

//           <div className="flex justify-between gap-4 h-full">
//             {[...Array(1)].map((_, idx) => (
//               <div
//                 key={idx}
//                 className="flex flex-col gap-2 bg-gray-300 w-full h-full rounded-lg p-2"
//               >
//                 <div className="flex-1 flex flex-wrap gap-1">
//                   {[...Array(6)].map((_, i) => (
//                     <div
//                       key={i}
//                       className="w-[30%] h-6 bg-gray-200 rounded"
//                     ></div>
//                   ))}
//                 </div>

//                 <div className="w-full h-8 bg-gray-200 rounded"></div>
//               </div>
//             ))}
//           </div>

//           <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
//             {[...Array(5)].map((_, i) => (
//               <div key={i} className="w-2 h-2 bg-gray-300 rounded-full"></div>
//             ))}
//           </div>
//         </div>
//         <div className="flex flex-col md:flex-row gap-8 p-6 bg-gray-50 rounded-lg animate-pulse">
//           <div className="flex-1 space-y-4">
//             <div className="w-24 h-8 bg-green-200 rounded"></div>
//             <div className="h-10 w-3/4 bg-gray-300 rounded"></div>
//             <div className="flex items-center gap-2">
//               <div className="w-4 h-4 bg-red-300 rounded-full"></div>
//               <div className="h-4 w-1/2 bg-gray-300 rounded"></div>
//             </div>
//             <div className="h-5 w-24 bg-red-300 rounded"></div>
//             <div className="h-4 w-2/3 bg-gray-200 rounded"></div>

//             <div className="h-5 w-32 bg-red-300 rounded mt-6"></div>
//             <div className="flex gap-8">
//               <div className="space-y-2">
//                 <div className="h-4 w-10 bg-gray-200 rounded"></div>
//                 <div className="h-4 w-16 bg-gray-300 rounded"></div>
//               </div>
//               <div className="space-y-2">
//                 <div className="h-4 w-24 bg-gray-200 rounded"></div>
//                 <div className="h-4 w-10 bg-gray-300 rounded"></div>
//               </div>
//             </div>
//           </div>

//           <div className="flex-1 space-y-4">
//             <div className="h-8 w-3/4 bg-gray-300 rounded"></div>
//             <div className="h-4 w-full bg-gray-200 rounded"></div>
//             <div className="h-12 w-full bg-gray-200 rounded"></div>
//             <div className="h-12 w-full bg-gray-200 rounded"></div>
//             <div className="h-12 w-full bg-gray-200 rounded"></div>
//             <div className="h-24 w-full bg-gray-200 rounded"></div>
//             <div className="h-12 w-full bg-red-300 rounded"></div>
//           </div>
//         </div>
//       </>
//     );
//   }

//   if (!singleProject) {
//     return (
//       <div className="min-h-screen flex items-center justify-center">
//         Project not found
//       </div>
//     );
//   }

//   return (
//     <div className="overflow-hidden">
//       <div className="lg:px-12 px-8 mt-2 lg:mt-8">
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//           {/* Left Column - Main Content */}
//           <div className="lg:col-span-2">
//             <ProjectDetailsPartOne projectData={singleProject} />
//           </div>

//           {/* Right Column - Inquiry Form, Phone & Map */}
//           <div className="lg:col-span-1">
//             <div className="sticky top-4">
//               <ProjectDetailsPartTwo projectData={singleProject} />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProjectDetails;

import React, { useEffect, useState } from "react";
import ProjectDetailsPartOne from "../../components/ProjectPageComponents/ProjectDetailsPartOne";
import ProjectDetailsPartTwo from "../../components/ProjectPageComponents/ProjectDetailsPartTwo";
import ProjectDetailsPartThree from "../../components/ProjectPageComponents/ProjectDetailsPartThree";
import Slider from "../../components/ProjectPageComponents/Slider";
import { useParams } from "react-router-dom";
import axios from "axios";

const ProjectDetails = () => {
  const { id } = useParams();
  const [singleProject, setSingleProject] = useState(null);
  const [loading, setLoading] = useState(true);

  const ProductDetail = () => {
    let data = "";

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/projects/project-by-id/${id}`,
      headers: {},
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setSingleProject(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    ProductDetail();
  }, [id]);

  if (loading) {
    return (
      <>
        <div className="relative w-full h-[500px] bg-gray-100 overflow-hidden p-4 animate-pulse">
          <div className="absolute top-1/2 left-4 -translate-y-1/2 w-8 h-8 rounded-full bg-gray-300"></div>

          <div className="absolute top-1/2 right-4 -translate-y-1/2 w-8 h-8 rounded-full bg-gray-300"></div>

          <div className="flex justify-between gap-4 h-full">
            {[...Array(1)].map((_, idx) => (
              <div
                key={idx}
                className="flex flex-col gap-2 bg-gray-300 w-full h-full rounded-lg p-2"
              >
                <div className="flex-1 flex flex-wrap gap-1">
                  {[...Array(6)].map((_, i) => (
                    <div
                      key={i}
                      className="w-[30%] h-6 bg-gray-200 rounded"
                    ></div>
                  ))}
                </div>

                <div className="w-full h-8 bg-gray-200 rounded"></div>
              </div>
            ))}
          </div>

          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="w-2 h-2 bg-gray-300 rounded-full"></div>
            ))}
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-8 p-6 bg-gray-50 rounded-lg animate-pulse">
          <div className="flex-1 space-y-4">
            <div className="w-24 h-8 bg-green-200 rounded"></div>
            <div className="h-10 w-3/4 bg-gray-300 rounded"></div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-red-300 rounded-full"></div>
              <div className="h-4 w-1/2 bg-gray-300 rounded"></div>
            </div>
            <div className="h-5 w-24 bg-red-300 rounded"></div>
            <div className="h-4 w-2/3 bg-gray-200 rounded"></div>

            <div className="h-5 w-32 bg-red-300 rounded mt-6"></div>
            <div className="flex gap-8">
              <div className="space-y-2">
                <div className="h-4 w-10 bg-gray-200 rounded"></div>
                <div className="h-4 w-16 bg-gray-300 rounded"></div>
              </div>
              <div className="space-y-2">
                <div className="h-4 w-24 bg-gray-200 rounded"></div>
                <div className="h-4 w-10 bg-gray-300 rounded"></div>
              </div>
            </div>
          </div>

          <div className="flex-1 space-y-4">
            <div className="h-8 w-3/4 bg-gray-300 rounded"></div>
            <div className="h-4 w-full bg-gray-200 rounded"></div>
            <div className="h-12 w-full bg-gray-200 rounded"></div>
            <div className="h-12 w-full bg-gray-200 rounded"></div>
            <div className="h-12 w-full bg-gray-200 rounded"></div>
            <div className="h-24 w-full bg-gray-200 rounded"></div>
            <div className="h-12 w-full bg-red-300 rounded"></div>
          </div>
        </div>
      </>
    );
  }

  if (!singleProject) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Project not found
      </div>
    );
  }

  return (
    <div className="h-full">
      <div className="lg:px-12 px-8 mt-2 lg:mt-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left Column - Scrollable */}
          <div className="lg:col-span-2 xl:h-[calc(100vh+330px)] lg:h-[calc(100vh+660px)] overflow-y-auto pr-2 hide-scrollbar pb-6">
            <ProjectDetailsPartOne projectData={singleProject} />
          </div>

          {/* Right Column - Fixed position */}
          <div className="lg:col-span-1 pl-2">
            <ProjectDetailsPartTwo projectData={singleProject} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;
